// What CreateStack sends and keeps, as pure functions so the privacy rules
// around a logged-out visitor's medications can be tested without the page
// (STACK-565; docs/guest-medication-check.md §3, steps 2 and 6, and §3.1).

/**
 * The /v2/generate-stack request body. It never carries medications:
 * `@cache_response_async` writes the whole body to a Supabase row
 * (`async_job_cache.input_params`), and the guest check finds the stack by
 * rebuilding this exact body from the goal text.
 */
export const generationRequestBody = (healthGoals, age, gender) => ({
  healthGoals,
  age,
  gender,
});

/**
 * The `unsavedStack_<id>` snapshot `saveStateAndNavigate` writes to
 * localStorage. For a logged-out visitor, no supplement keeps an
 * `interaction` object: they name medications and carry the AI's reasoning,
 * and the snapshot can outlive the tab. Members' snapshots are unchanged.
 */
export const buildStackSnapshot = ({
  supplements,
  stackName,
  healthGoals,
  citations,
  drawerInfo = null,
  generatedGoals = '',
  generatedKeys = [],
  loggedIn,
  now = Date.now(),
}) => ({
  supplements: loggedIn
    ? supplements
    : (supplements || []).map((s) => {
      if (!s || typeof s !== 'object' || !('interaction' in s)) return s;
      const { interaction, ...rest } = s;
      return rest;
    }),
  stackName,
  healthGoals,
  citations,
  // The goal string and supplement keys the generator used, so a restored
  // stack can re-run the guest check against the same cached stack. No
  // medication data: the medications stay in the tab store.
  generatedGoals,
  generatedKeys,
  timestamp: now,
  drawerState: drawerInfo ? { isOpen: true, ...drawerInfo } : { isOpen: false },
});
